import { createAction } from "redux-actions";

export const getNormalizersList = createAction("GET_NORMALIZERS_LIST");
export const setNormalizers = createAction("SET_NORMALIZERS");
